<template>
  <div class="rankinglist">
    <div class="auto clearfix">
      <div class="title">
        <img src="../assets/image/rankingtitle.jpg" alt />
        <span class="font">每日 10:00,22:00 数据更新</span>
      </div>
      <div class="list" id="paihang">
        <el-table :data="tableData" stripe style="width: 1200px">
          <el-table-column prop="order" label="排行" width="150"></el-table-column>
          <el-table-column prop="member.name" label="用户名" width="300">
            <template slot-scope="scope">
              <el-image class="tx" style="width: 45px; height: 45px" :src="scope.row.member.url"></el-image>
              <span class="mz" style="margin-left: 15px">{{scope.row.member.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="tiezi.title" width="400" label="主贴">
            <template slot-scope="scope">
              <a :href="scope.row.tiezi.a" target="_blank">
                <span>{{scope.row.tiezi.title}}</span>
              </a>
            </template>
          </el-table-column>
          <el-table-column prop="zan" label="点赞排行">
            <template slot-scope="scope">
              <span>{{scope.row.zan+'赞'}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="move">
        <span class="Return" @click="$emit('disnone')">返回上一级</span>
        <!-- <el-button type="primary" id="cliMove" class="cliMove" :loading="loa" @click="load">点击查看更多</el-button> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loa: false,
      tableData: [],
      num: 2 //页数
    };
  },
  created() {
    axios.get("/ajax/act_tj_all.php").then(res => (this.tableData = res.data));
  },
  methods: {
    load() {
      this.loa = !this.loa;

      setTimeout(() => {
        this.loa = !this.loa;
        axios
          .post(`/ajax/act_tj.php?page=${this.num}/`, { num: this.num })
          .then(res => {
            if (res.data.length == []) {
              this.$message({
                showClose: true,
                message: "没有更多了！"
              });
              return;
            } else {
              this.num++;
              for (let key in res.data) {
                this.tableData.push(res.data[key]);
              }
            }
          });
      }, 500);
    }
  }
};
</script>
<style scoped>
.el-table .cell a {
  position: relative;
  max-width: 380px;
  color: #000;
  text-decoration: none;
}
.el-table .cell a span {
  max-width: 380px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-table .cell a::after {
  position: absolute;
  content: "";
  left: 0;
  width: 1px;
  bottom: -2px;
  opacity: 0;
  border-top: 1px solid #000;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
}
.el-table .cell a:hover::after {
  width: 100%;
  opacity: 1;
}
.rankinglist {
  float: left;
  width: 100%;
  min-width: 1300px;
  /* height: 1150px; */
  padding-bottom: 50px;
  background: #fff;
}
.auto {
  width: 1300px;
  margin: 0 auto;
}
.title {
  position: relative;
  float: left;
  width: 100%;
  height: 147px;
  margin-top: 15px;
}
.title img {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -o-transform: translateX(-50%);
}
.font {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 14px;
  color: #ccc;
}
.Return {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  bottom: 10px;
  color: #333;
  font-size: 24px;
  cursor: pointer;
}
.Return::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 0px;
  border-bottom: 1px solid #333;
  transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
}
.Return:hover::after {
  width: 100%;
}
.list {
  float: left;
  width: 1200px;
  margin: 55px 50px 0 50px;
}
.el-table td .tx {
  /* display: inline-block; */
  float: left;
  margin-left: 80px;
  width: 45px;
  border-radius: 50%;
}
.el-table td .mz {
  float: left;
  height: 51px;
  line-height: 51px;
  max-width: 112px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.move {
  position: relative;
  float: left;
  width: 1200px;
  height: 48px;
  margin: 50px;
  margin-bottom: 0;
}
.move #cliMove {
  position: absolute;
  left: 42%;
  top: 0;
  /* margin-left: -98px; */
  width: 196px;
  height: 48px;
  margin: 0 auto;
  background: transparent;
  font-size: 22px;
  color: #000;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  border-color: rgb(122, 66, 66);
}
.el-button.is-loading:before {
  background: transparent;
}
</style>